/** 进入 /sign-in 时通过 location.state 传入，用于「返回」落到首页或「我的」 */
export type SignInLocationState = { signInReturnTo?: '/' | '/profile' };

export function getSignInReturnTo(state: unknown): '/' | '/profile' {
  if (state && typeof state === 'object' && 'signInReturnTo' in state) {
    const v = (state as SignInLocationState).signInReturnTo;
    if (v === '/profile') return '/profile';
  }
  return '/';
}

export function signInStateHome(): SignInLocationState {
  return { signInReturnTo: '/' };
}

export function signInStateProfile(): SignInLocationState {
  return { signInReturnTo: '/profile' };
}
